import { CircularProgress } from "@material-ui/core";
import { Form, Formik } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormGroup } from "reactstrap";
import cameraIcon from "../../../assets/images/stream1.png";
import CustomDropDown from "../../../Common/FormFields/CustomDropDown";
import { openFailDialog } from "../../../Redux/Actions/PopupActions";
import {
  addAvsChannelDetails,
  setIVSCameraAngle,
  setOpenStreamCamera,
} from "../../../Redux/Actions/VideoStreamingActions";
import userService from "../../../services/user.service";
import { getFromLocalStorage } from "../../../utils/webStorage";
import validationSchema from "../../../Validation/ValidationSchemas";
import styles from "../Video Streaming/IP Camera Video Streaming/IPCameraVideoStreaming.module.css";
import DialogBox from "./ReusablePopup/DialogBox";

const IPCameraConnectionRequestPopup = ({ open, setOpen, socket }) => {
  const schoolId = getFromLocalStorage("schoolId");
  const [cameraAngle, setCameraAngle] = useState("");
  const [loading, setLoading] = useState(false);
  const schoolName = getFromLocalStorage("schoolName");
  const userId = getFromLocalStorage("currentUserId");
  const dispatch = useDispatch();
  const videoStreamAvsChannelList = useSelector(
    (state) => state?.videoStreamData?.videoStreamAvsChannelList
  );
  const videoScheduleInformation = useSelector(
    (state) => state?.videoScheduleInformation
  );
  const currentSeason = useSelector(
    (state) => state.loggedInUser?.userProfile?.currentSeason
  );
  const cameraAngles = useSelector(
    (state) => state?.videoStreamData?.IPCameraAngles
  );

  useEffect(() => {
    cameraAngles?.forEach((ele1) => {
      videoStreamAvsChannelList?.forEach((ele2) => {
        if (ele1.angleName === ele2.angle) {
          ele1.allocated = true;
        }
        if (userId === ele2?.userId?.toString()) {
          ele1.allocated = false;
        }
      });
    });
    setIVSCameraAngle(dispatch, cameraAngles);
    setLoading(false);
  }, []);

  const handleRequestSubmit = (values) => {
    setLoading(true);
    let { cameraAngle } = values;
    let channelName = (
      cameraAngle.split(" ").join("_") +
      "_" +
      schoolName.split(" ").join("_") +
      "_" +
      moment(new Date()).format("YYYY-MM-DD")
    ).toUpperCase();
    const streamingStartTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    userService
      .createChannel(channelName, cameraAngle)
      .then((response) => {
        const { playbackUrl, ingestUrl, streamKey, channelArn } =
          response?.data?.data;
        //first channel = primary channel
        if (videoStreamAvsChannelList.length === 0) {
          const opponentSchoolId = videoScheduleInformation.opponentId
            ? videoScheduleInformation.opponentId
            : videoStreamAvsChannelList[0].opponentSchoolId;
          const {
            uploadVideoEventType = "",
            practice = "",
            uploadvideoEvent = "",
            uploadVideoWeek = "",
            uploadVideoOffSeasonEventName = "",
            otherEventName = "",
            playlistData = [],
            uploadPlaylistName = "",
            uploadVideoWeekName = "",
          } = videoScheduleInformation;
          const eventName =
            uploadVideoOffSeasonEventName || otherEventName || "";
          const playlistId = playlistData?.filter(
            (ele) => ele.playlistName === uploadPlaylistName
          )[0]?.id;
          addAvsChannelDetails(dispatch, {
            streamingStartTime,
            playbackUrl,
            ingestUrl,
            streamKey,
            channelArn,
            channelName,
            angle: cameraAngle,
            isAssigned: true,
            homeSchoolId: schoolId,
            opponentSchoolId: opponentSchoolId,
            eventType: uploadVideoEventType,
            eventName,
            practiceName: practice,
            seasonType: uploadvideoEvent,
            scheduleId: uploadVideoWeek,
            isPractice: uploadvideoEvent === "Off-Season" ? true : false,
            seasonId: currentSeason?.id,
            playListId: playlistId,
            isPrimaryChannel: true,
            playlistName: uploadPlaylistName,
            userId,
            weekName: uploadVideoWeekName,
          });
          //for other channel
        } else {
          const data = videoStreamAvsChannelList.filter(
            (ele) => ele.isPrimaryChannel == true
          )[0];
          const {
            eventType,
            eventName,
            practiceName,
            seasonType,
            scheduleId,
            seasonId,
            playlistId,
            isPractice,
            opponentSchoolId,
            playlistName,
            weekName,
          } = data;
          addAvsChannelDetails(dispatch, {
            streamingStartTime,
            playbackUrl,
            ingestUrl,
            streamKey,
            channelArn,
            channelName,
            angle: cameraAngle,
            isAssigned: true,
            homeSchoolId: schoolId,
            opponentSchoolId,
            isPrimaryChannel: data.userId.toString() === userId ? true : false,
            eventType,
            eventName,
            practiceName,
            seasonType,
            scheduleId,
            isPractice,
            seasonId,
            playlistName,
            playListId: playlistId,
            userId,
            weekName,
          });
        }
        setOpen(false);
        setOpenStreamCamera(dispatch, true);
        setLoading(false);
      })
      .catch((error) => {
        setOpen(false);
        setLoading(false);
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  const handleRequestCancel = () => {
    setOpen(false);
  };

  return (
    <DialogBox
      open={open}
      onClose={() => handleRequestCancel()}
      variant="xs"
      title={
        <div className={styles.popupHeader}>
          <p className="bold">
            <img src={cameraIcon} className="mg-right-10" />
            Connect Camera
          </p>
          <p className={styles.closeIcon} onClick={() => handleRequestCancel()}>
            &times;
          </p>
        </div>
      }
    >
      <Formik
        initialValues={{
          cameraAngle: "",
        }}
        validationSchema={validationSchema?.IPCameraConnectionSchema}
        onSubmit={(values) => handleRequestSubmit(values)}
      >
        {(formik) => (
          <Form className="font-rajdhani popup-height">
            <FormGroup>
              <label className="fmlabel mt-6 semi-bold fs-18">
                Camera Angle <span className="redstar">*</span>
              </label>
              <CustomDropDown
                selected={cameraAngle}
                setSelected={setCameraAngle}
                formik={formik}
                fieldName="cameraAngle"
                defaultSelectOption="Select Camera Angle"
                options={cameraAngles}
                fieldToShow="angleName"
                optionValue="angleName"
                isDisabled="allocated"
              />
            </FormGroup>
            <div className="text-center mt-40-per">
              <button
                className={`common-btn green ${
                  !formik.isValid && styles.disabled
                }`}
                type="submit"
                disabled={!formik.isValid}
              >
                {loading ? (
                  <div className="blur-filter-background w-100 h-100">
                    <CircularProgress size="1.5rem" className="white" />
                  </div>
                ) : (
                  <span
                    className={`styles.disabled
                    }`}
                  >
                    Add Camera
                  </span>
                )}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </DialogBox>
  );
};

export default IPCameraConnectionRequestPopup;
